/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { OtpRequestDto } from '../../models/otp-request-dto';
import { UpdateEmailDto } from '../../models/update-email-dto';

export interface UpdateEmailStep1$Params {
      body: UpdateEmailDto
}

export function updateEmailStep1(http: HttpClient, rootUrl: string, params: UpdateEmailStep1$Params, context?: HttpContext): Observable<StrictHttpResponse<OtpRequestDto>> {
  const rb = new RequestBuilder(rootUrl, updateEmailStep1.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<OtpRequestDto>;
    })
  );
}

updateEmailStep1.PATH = '/api/v1/customer/email/init';
